import { FC, useEffect, useState } from 'react';
import { Grid as KendoGrid, GridColumn } from '@progress/kendo-react-grid';
import { State as ODataState } from '@progress/kendo-data-query';
import ItemApi from 'src/api/ItemApi';
import UomCell from 'src/components/grid/UomCell';
import { ItemUnits } from 'src/types/itemUnits';
import { ItemDetails } from 'src/types/itemList';
import { Box } from '@mui/material';
import { ItemDocument } from 'src/types/itemDocument';
import ItemDocumentLink from './itemDocumentLink';
declare interface IProps {
  itemNumber: string;
  itemWeight?: number;
  visible: boolean;
}

const ItemDetailInfo: FC<React.PropsWithChildren<IProps>> = ({ itemNumber, itemWeight, visible }) => {
  const [itemUnits, setItemUnits] = useState<ItemUnits[]>();
  const [itemDocuments, setItemDocuments] = useState<ItemDocument[]>();
  const [itemDetails, setItemDetails] = useState<ItemDetails>();
  const [gridDataState, setGridDataState] = useState<ODataState>({});

  useEffect(() => {
    if (itemNumber) {
      ItemApi.getItemUnits(itemNumber).then((data) => setItemUnits(data));
      ItemApi.getItemDetails(itemNumber).then((data) => setItemDetails(data));
      ItemApi.getItemDocuments(itemNumber).then((data) => setItemDocuments(data));
    }
  }, [gridDataState, itemNumber]);

  const handleGridDataStateChange = (e: any) => {
    setGridDataState(e.dataState);
  };

  const qtyCell = (cellProps) => <UomCell {...cellProps} uomField="unitOfMeasure" />;

  return (
    <div role="tabpanel" hidden={!visible} id="on-order" aria-labelledby="on-order-tab">
      <Box className="item-detail-info">
        <Box sx={{ mb: 4, mt: 3, px: 3 }}>
          <div>
            <strong>UPC:</strong> {itemDetails && itemDetails.upc}
          </div>
          <div>
            <strong>BFG Short Sku:</strong> {itemDetails && itemDetails.bfgShortSku}
          </div>
          <div>
            <strong>Base Price:</strong> {itemDetails && itemDetails.listPrice}
          </div>
          <div>
            <strong>Item Weight:</strong> {`${itemWeight} lbs`}
          </div>
          <div>
            <strong>Documents:</strong> {itemDocuments && itemDocuments.length > 0 && itemDocuments.map((d, index) => <ItemDocumentLink key={d.name || index} document={d}></ItemDocumentLink>)}
          </div>
          <div>
            <strong>Buyer(s): </strong>
            {itemDetails?.buyers &&
              itemDetails.buyers.map((b, index) => (
                <div key={b.email || index}>
                  <a className="item-detail-buyer text-link" href={`mailto:${b.email}`}>
                    {b.username} ({b.email})
                  </a>
                  <br />
                </div>
              ))}
            {itemDetails?.buyers == null && 'None'}
          </div>
          <div>
            <strong>Web Description:</strong>
          </div>
          <div style={{ maxWidth: '500px', whiteSpace: 'break-spaces' }} dangerouslySetInnerHTML={{ __html: itemDetails && itemDetails.description }}></div>
        </Box>
        <KendoGrid data={itemUnits} scrollable="scrollable" onDataStateChange={handleGridDataStateChange} {...gridDataState}>
          <GridColumn field="description" title="Description" width={140} />
          <GridColumn field="conversionRate" cells={{ data: qtyCell }} format="0.00" title="ConversionRate" width={130} />
          <GridColumn field="" title="" editable={false} />
        </KendoGrid>
      </Box>
    </div>
  );
};

export default ItemDetailInfo;
